export enum OwnerType {
  Space = 'Space'
}
